import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  fullWidth: {
    width: "100%",
  },
  paper: {
    maxHeight: "100vh",
    height: "100vh",
  },
  root: {
    margin: 0,
    // marginLeft: -8,
    borderRadius: 0,
    marginTop: 50
  },
  btn: {
    textTransform: "capitalize",
  },
  hero: {
    objectFit: "cover",
    width: "100%",
    // height: 200,
  },
  wrapHeader: {
    textAlign: "center",
    marginTop: "70px",
  },
  liquidTitle: {
    fontWeight: "bold",
    color: theme.palette.textColor.primeTextColor,
  },
  liquidBold: {
    fontSize: 16,
    marginLeft: "1.5%",
    fontWeight: "bold",
  },
  liquidPrimary: {
    fontSize: 14,
  },
  liquidPrimaryCa: {
    fontSize: 14,
    textTransform: "capitalize",
  },
  liquidSecond: {
    fontSize: 14,
    color: theme.palette.textColor.gray,
  },
  liquidSecondCa: {
    fontSize: 13,
    textTransform: "capitalize",
  },
  liquidBlue: {
    fontSize: 13,
    textTransform: "capitalize",
    color:"#587CD4"
  },
  liquidSecondList: {
    fontSize: 12,
    color: theme.palette.textColor.gray,
  },
  liquidThird: {
    fontSize: 12,
    color: theme.palette.primary.main,
  },
  liquidWa: {
    fontSize: 12,
    color: "#4DC897",
  },
  liquidOrange: {
    fontSize: 13,
    color: "#FDB429",
    textTransform: "capitalize",
  },
  secondItem: {
    marginTop: "20px",
  },
  wrapBtnList: {
    display: "flex",
    justifyContent: "center",
  },
  wrapList: {
    marginTop: "90px",
  },
}));

export default useStyles;
